import { Direction } from '@angular/cdk/bidi';
import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InConfiguration } from 'src/app/all-modules/core/models/config.interface';
import { DirectionService } from 'src/app/all-modules/core/service/direction.service';
import { CommonService } from 'src/app/all-modules/shared/services/common.service';

import { ConfigService } from 'src/app/config/config.service';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MainLayoutComponent {
  direction!: Direction;
  isHideSidebarHeader = false;
  public config!: InConfiguration;
  constructor(
    private directoryService: DirectionService,
    private configService: ConfigService,
    private commonService:CommonService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.config = this.configService.configData;
    this.directoryService.currentData.subscribe((currentData) => {
      if (currentData) {
        this.direction = currentData === 'ltr' ? 'ltr' : 'rtl';
      } else {
        if (localStorage.getItem('isRtl')) {
          if (localStorage.getItem('isRtl') === 'true') {
            this.direction = 'rtl';
          } else if (localStorage.getItem('isRtl') === 'false') {
            this.direction = 'ltr';
          }
        }
      }
    });
  }
  ngOnInit() {
    this.commonService.currentIsHideSidebarValue.subscribe(
      value => this.isHideSidebarHeader = value
    );
    this.cdr.detectChanges();
  }
}
